import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useState } from "react";
import { Sidebar } from "primereact/sidebar";
import { useMainLayoutStore } from "@/shared/zustand/mainLayoutStore";
import { InstantLearningContent } from "./InstantLearningSidebar";
import { FeedbackContent } from "./FeedbackSidebar";
const LearningSidebarContainer = ({ feedbackData, feedbackParentRef, instantLearningData }) => {
    const { sidebarType, setSidebarType } = useMainLayoutStore();
    const [fromInstantLearning, setFromInstantLearning] = useState(false);
    const [instantLearningFeedback, setInstantLearningFeedback] = useState(null);
    const handleHide = () => {
        setSidebarType(null);
        setFromInstantLearning(false);
        setInstantLearningFeedback(null);
    };
    const handleProvideFeedback = (newFeedbackData) => {
        setInstantLearningFeedback(newFeedbackData);
        setFromInstantLearning(true);
        setSidebarType("feedback");
    };
    const handleFeedbackClose = () => {
        if (fromInstantLearning) {
            setSidebarType("instant-learning");
        }
        else {
            setSidebarType(null);
        }
        setFromInstantLearning(false);
        setInstantLearningFeedback(null);
    };
    const getSidebarTitle = () => {
        if (sidebarType === "instant-learning") {
            return "Instant Learnings for your edits";
        }
        return "Provide us with Instant Learning";
    };
    return (_jsxs(Sidebar, { appendTo: feedbackParentRef?.current, visible: Boolean(sidebarType), position: "right", onHide: handleHide, className: "feedback-sidebar border-l border-[#d1d5db] w-full sm:!w-[500px]", 
        // header={
        //   <div className="flex justify-between items-center p-3">
        //     <h2 className="text-xl font-semibold">{getSidebarTitle()}</h2>
        //     <Button
        //       icon="pi pi-times"
        //       className="p-button-text"
        //       onClick={handleHide}
        //     />
        //   </div>
        // }
        header: _jsx("h2", { className: "text-lg font-semibold font-content", children: getSidebarTitle() }), dismissable: false, maskClassName: "!absolute !left-auto !right-0 !w-fit !rounded-[8px] backdrop-none !bg-transparent !border-0", children: [sidebarType === "instant-learning" && (_jsx(InstantLearningContent, { instantLearningData: instantLearningData, onProvideFeedback: handleProvideFeedback })), sidebarType === "feedback" && (_jsx(FeedbackContent, { onHide: handleFeedbackClose, feedbackData: fromInstantLearning ? instantLearningFeedback : feedbackData, fromInstantLearning: fromInstantLearning }))] }));
};
export default LearningSidebarContainer;
